import { SentryService, type SentryEnvironment } from '@travelata-libs/utils';
import Cookies from 'js-cookie';

declare const SENTRY_DSN: string;
declare const SENTRY_ENVIRONMENT: SentryEnvironment;
declare const SENTRY_RELEASE: string;

const sentryService = new SentryService({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    release: SENTRY_RELEASE,
    userId: Cookies.get('clientUuid'),
    tracesSampleRate: 0.001, 
    withReplay: true,
    maskAllInputs: false,
    maskAllText: false,
    blockAllMedia: true,
});

export default sentryService;
